export default [
  {
    accordionTitle: 'Learn more about quantum datasets',
    materialLinks: [
      {
        label: 'What are Quantum Datasets',
        link: '/what-is-a-quantum-dataset',
        image: 'https://assets.cloud.pennylane.ai/datasets/generic/what_are_qd.png',
      },
      {
        label: 'Classical Datasets for PennyLane',
        link: '/conventional-datasets-for-qml',
        image: 'https://assets.cloud.pennylane.ai/datasets/generic/thumbnail/Dataset_Thumb_Generic.png',
      },
      {
        label: 'Main documentation about datasets',
        link: 'https://docs.pennylane.ai/en/stable/introduction/data.html',
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
      },
    ],
  },
  {
    accordionTitle: 'Demos',
    materialLinks: [
      {
        label: 'Measurement optimization',
        link: 'https://pennylane.ai/qml/demos/tutorial_measurement_optimize',
        image: 'https://assets.cloud.pennylane.ai/datasets/learning_materials/grouping.png',
      },
      {
        label: 'Accelerating VQEs with quantum natural gradient',
        link: 'https://pennylane.ai/qml/demos/tutorial_vqe_qng',
        image: 'https://assets.cloud.pennylane.ai/datasets/learning_materials/sphx_glr_tutorial_vqe_qng_001.png',
      },
      {
        label: 'Classical shadows',
        link: 'https://pennylane.ai/qml/demos/tutorial_classical_shadows',
        image: 'https://assets.cloud.pennylane.ai/datasets/learning_materials/atom_shadow.png',
      },
      {
        label: 'Building molecular Hamiltonians',
        link: 'https://pennylane.ai/qml/demos/tutorial_quantum_chemistry',
        image: 'https://assets.cloud.pennylane.ai/datasets/learning_materials/water_structure.png',
      },
      {
        label: 'Training and evaluating quantum kernels',
        link: 'https://pennylane.ai/qml/demos/tutorial_kernels_module',
        image: 'https://assets.cloud.pennylane.ai/datasets/learning_materials/linear_classification.png',
      },
      {
        label: 'Tensor-network quantum circuits',
        link: 'https://pennylane.ai/qml/demos/tutorial_tn_circuits',
        image:
          'https://assets.cloud.pennylane.ai/datasets/learning_materials/sphx_glr_tutorial_tn_circuits_005.png',
      },
    ],
  },
  {
    accordionTitle: 'Documentation',
    materialLinks: [
      {
        label: 'qml.data.load',
        link: 'https://docs.pennylane.ai/en/stable/code/api/pennylane.data.load.html',
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
      },
      {
        label: 'qml.data.list_datasets',
        link: 'https://docs.pennylane.ai/en/stable/code/api/pennylane.data.list_datasets.html',
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
      },
      {
        label: 'qml.data.list_attributes',
        link: 'https://docs.pennylane.ai/en/stable/code/api/pennylane.data.list_attributes.html',
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
      },
      {
        label: 'qml.data.Dataset',
        link: 'https://docs.pennylane.ai/en/stable/code/api/pennylane.data.Dataset.html',
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
      },
    ],
  },
]
